import React from 'react';
import {EditorState} from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function TextEditor() {
  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty(),
  );
  const onEditorStateChange = function (editorState) {
    setEditorState(editorState);
  };
  return <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} toolbarClassName="toolbarClassName"
  wrapperClassName="wrapperClassName"
  editorClassName="editorClassName" mention={{
    separator: " ",
    trigger: "@",
    suggestions: [
      { text: "APPLE", value: "apple" },
      { text: "BANANA", value: "banana", url: "banana" },
      { text: "CHERRY", value: "cherry", url: "cherry" },
      { text: "DURIAN", value: "durian", url: "durian" },
      { text: "EGGFRUIT", value: "eggfruit", url: "eggfruit" },
      { text: "FIG", value: "fig", url: "fig" },
      { text: "GRAPEFRUIT", value: "grapefruit", url: "grapefruit" },
      { text: "HONEYDEW", value: "honeydew", url: "honeydew" }
    ]
  }} />;
}